import * as React from 'react'
import classNames from 'classnames'
import { NonThrowingComponent } from './NonThrowingComponent'
import { TodoItem } from './TodoItem'
import { TodoItemDetails } from './TodoItemDetails'
import { TodoItemIcon } from './TodoItemIcon'
import { TodoItemSubtitle } from './TodoItemSubtitle'
import { TodoItemTitle } from './TodoItemTitle'
import { TodoLeftItemDetails } from './TodoLeftItemDetails'
import { MissingTrainingLozenge } from './MissingTrainingLozenge'

interface Props {
    onClick: () => void
    procedureName?: string
    selected: boolean
    workflowName: string
    workflowType: 'guide' | 'task' | 'training'
    hasMissingTrainingRecommendations?: boolean
}

export class WorkflowItem extends NonThrowingComponent<Props, {}> {
    public tryRender() {
        const { selected, workflowType, workflowName, procedureName, hasMissingTrainingRecommendations, onClick } =
            this.props

        return (
            <div
                data-testid="AppCore__ui__WorkflowItem"
                className={classNames('AppCore__ui__WorkflowItem', { 'AppCore__ui__WorkflowItem-selected': selected })}
            >
                <TodoItem onClick={onClick}>
                    <TodoItemIcon icon={workflowType} mode="active" />
                    <TodoItemDetails>
                        <TodoLeftItemDetails>
                            <div className="AppCore__ui__WorkflowItem__ItemDetails">
                                {hasMissingTrainingRecommendations && <MissingTrainingLozenge />}
                                <div>
                                    <TodoItemTitle isConfidential={false} title={workflowName} />
                                    {procedureName && <TodoItemSubtitle subtitle={procedureName} />}
                                </div>
                            </div>
                        </TodoLeftItemDetails>
                    </TodoItemDetails>
                </TodoItem>
            </div>
        )
    }
}
